'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

const MAX_TIMER_DELAY_MS = 60_000

export default function useMysteryTrackRevealRefresh(event: {
  trackIsHidden?: boolean
  trackRevealAt?: Date | string | null
}) {
  const router = useRouter()
  const trackIsHidden = event?.trackIsHidden === true
  const revealAt = event?.trackRevealAt

  useEffect(() => {
    if (!trackIsHidden || !revealAt) return

    const revealTime = new Date(revealAt).getTime()
    if (Number.isNaN(revealTime)) return

    let timeoutId: ReturnType<typeof setTimeout> | undefined

    const scheduleRefresh = () => {
      const remaining = revealTime - Date.now()
      if (remaining <= 0) {
        router.refresh()
        return
      }

      timeoutId = setTimeout(
        scheduleRefresh,
        Math.min(remaining, MAX_TIMER_DELAY_MS),
      )
    }

    scheduleRefresh()
    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [revealAt, router, trackIsHidden])
}
